// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3930de16","341":"1c0abd9e","757":"d15b40c2","941":"b261648d","979":"4ed846ad"}[chunkId] + ".chunk.js";
};